import React from 'react';
import Link from 'next/link';

import styles from './LayoutCardListHeading.module.scss';
import { Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';

import { rowHorizontalDefaultProps } from 'src/utils/grid';

interface LayoutCardListHeadingProps {
  title: string;
  seeAll?: string;
  link?: string;
  values?: Record<string, unknown>;
  svg?: JSX.Element;
  linkClass?: string;
}

export const LayoutCardListHeading: React.FunctionComponent<LayoutCardListHeadingProps> = (
  props
) => {
  const { title, values = {}, seeAll, link, svg = null, linkClass = '' } = props;
  return (
    <Row {...rowHorizontalDefaultProps} className={styles.container}>
      <Col xs={24}>
        <h3>
          <FormattedMessage id={title} values={values} />
        </h3>

        {!!seeAll && (
          <Link href={link}>
            <a className={linkClass}>
              <FormattedMessage id={seeAll} />
              &nbsp;{svg}
            </a>
          </Link>
        )}
      </Col>
    </Row>
  );
};

export default LayoutCardListHeading;
